module.exports = __webpack_public_path__ + "static/img/组 2@2x.7e70908d.png";